import React, { useCallback, useEffect, useState } from 'react';
import NavBar from '../../components/NavBar';
import './Home.css'; // Import CSS
import { Link, useNavigate } from 'react-router-dom';
import { db, collection, getDocs } from '../../firebaseConfiguration';
import Footer from '../../components/Footer';

const Home = () => {


    const [posts, setPosts] = useState([]);
    const [shufflePosts, setShufflePosts] = useState([]);
    const navigate = useNavigate();

    const shuffleArray = (array) => {
        for (let i = array.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [array[i], array[j]] = [array[j], array[i]];
        }
        return array;
    };

    const getPosts = useCallback(async () => {
        try {
            const querySnapshot = await getDocs(collection(db, "posts"));
            const postsData = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setPosts(postsData);
            setShufflePosts(shuffleArray([...postsData]));
            return postsData;
        } catch (error) {
            console.error('Error getting posts:', error);
        } finally {
            console.log('Done getting posts');
        }
    }, []);

    useEffect(() => {
        getPosts();
    }, [getPosts, navigate]);

    return (
        <div className='bg-white m-0 p-0'>
            <div style={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
                <div style={{ flex: '0 0 10%' }}>
                    <NavBar />
                </div>

                {/* banner */}
                <div className="container d-flex justify-content-center align-items-center" style={{ flex: '1 1 90%' }}>
                    <h1 className="text-dancing-script m-0 p-3">
                        An Classical là nơi chia sẻ kiến thức về âm nhạc, khám phá vẻ đẹp bất tận của nghệ thuật và cảm hứng từ những giai điệu vượt thời gian
                    </h1>
                </div>
            </div>

            {/* kien thuc */}
            <div className="mt-5 bg-black" style={{ padding: '1rem' }}>
                <div className="container py-3">
                    {/* Thanh tiêu đề */}
                    <div className="d-flex flex-row justify-content-between align-items-center">
                        <Link
                            to={'/knowledge'}
                            className='knowledge-link'
                        >
                            <h4 className="m-0">Kiến thức</h4>
                        </Link>
                        <Link
                            to={'/knowledge'}
                            className="btn btn-light btn-custom"
                        >
                            Xem tất cả
                        </Link>
                    </div>
                </div>

                {/* Hiển thị 3 item nằm ngang */}
                <div className="container" style={{ padding: '1rem' }}>
                    <div className="row">
                        {/* Chỉ hiển thị 3 bài post */}
                        {posts.slice(0, 3).map(post => (
                            <div key={post.id} className="col-12 col-md-4">
                                <div className="post-item position-relative">
                                    <img
                                        src={post.avatar || ''}
                                        alt={post.title || ''}
                                        className="img-fluid post-avatar"
                                    />
                                    <div className="post-overlay d-flex flex-column justify-content-center align-items-center p-3">
                                        <h5 className="text-white">{post.title || ''}</h5>
                                        <p className="text-white">{post.subtitle || ''}</p>
                                        <Link to={`/post-detail/${post.id}`} className="btn btn-light btn-custom">
                                            Xem chi tiết
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* theo doi */}
            <div className="container py-3">
                <div className="row align-items-center">
                    <div className="col-12 col-md-8 text-center text-md-start">
                        <h3 className="text-dancing-script mb-0" style={{ fontSize: 'clamp(1.2rem, 2vw, 1.4rem)' }}>
                            Theo dõi An Classical trên các nền tảng xã hội để không bỏ lỡ những cập nhật mới nhất
                        </h3>
                    </div>
                    <div className="col-12 col-md-4">
                        <div className="d-flex flex-row justify-content-center justify-content-md-end">
                            <Link>
                                <img
                                    src={'/tiktok_logo.png'}
                                    alt="tiktok"
                                    width="50"
                                    height="50"
                                    className="me-3 social-icon"
                                /></Link>
                            <Link>
                                <img
                                    src={'/fb_logo.png'}
                                    alt="facebook"
                                    width="50"
                                    height="50"
                                    className='me-3 social-icon'
                                /></Link>
                        </div>
                    </div>
                </div>
            </div>

            {/* san pham */}
            <div className="product-section" style={{ backgroundImage: 'url(/product_background.png)', height: '100vh' }}>
                <div className="text-overlay">
                    <Link
                        to={'/products'}
                        className='knowledge-link'>
                        <h4 style={{ fontSize: 'clamp(2rem, 2vw, 2rem)' }} className="">Sản phẩm</h4>
                    </Link>
                </div>
            </div>

            {/* gioi thieu */}
            <div className="d-flex flex-column flex-md-row" style={{ height: '100vh', overflow: 'hidden' }}>
                <div className="d-flex justify-content-center align-items-center" style={{ flex: '1 1 50%', overflow: 'hidden' }}>
                    <img src={'/avatar.png'} alt="avatar" className="custom-img" style={{ height: '100%', objectFit: 'cover' }} />
                </div>
                <div className="d-flex justify-content-center align-items-center" style={{ flex: '1 1 50%' }}>
                    <Link to={'/contact'} className='about-link'>
                        <h4 style={{ fontSize: 'clamp(1.5rem, 2vw, 2rem)' }} className="">An Classical là ai?</h4>
                    </Link>
                </div>
            </div>

            {/* co the ban quan tam */}
            <div className="bg-black" style={{ padding: '1rem' }}>
                <div className="container py-3">
                    {/* Thanh tiêu đề */}
                    <div className="d-flex flex-row justify-content-between align-items-center">
                        <Link
                            to={'/knowledge'}
                            className='knowledge-link'
                        >
                            <h4 className="m-0">Có thể bạn quan tâm</h4>
                        </Link>
                        <Link
                            to={'/knowledge'}
                            className="btn btn-light btn-custom"
                        >
                            Xem tất cả
                        </Link>
                    </div>
                </div>

                {/* Hiển thị 3 item nằm ngang */}
                <div className="container" style={{ padding: '1rem' }}>
                    <div className="row">
                        {/* Chỉ hiển thị 3 bài post */}
                        {shufflePosts.slice(0, 3).map(post => (
                            <div key={post.id} className="col-12 col-md-4">
                                <div className="post-item position-relative">
                                    <img
                                        src={post.avatar || ''}
                                        alt={post.title || ''}
                                        className="img-fluid post-avatar"
                                    />
                                    <div className="post-overlay d-flex flex-column justify-content-center align-items-center p-3">
                                        <h5 className="text-white">{post.title || ''}</h5>
                                        <p className="text-white">{post.subtitle || ''}</p>
                                        <Link to={`/post-detail/${post.id}`} className="btn btn-light btn-custom">
                                            Xem chi tiết
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* copyright */}
            <Footer />

        </div>
    );
};

export default Home;
